import { useSelector } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateTRSRegistration } from '@/API/TRSRegistration/updateTRSRegistration';

const useUpdateTRSRegistration = (onSuccess, onError) => {
    const queryClient = useQueryClient();
    const { requiredScope } = useSelector((state) => state.login);

    const mutation = useMutation({
        mutationFn: async (updateData) => {
            try {
                const response = await updateTRSRegistration(
                    updateData,
                    requiredScope,
                );
                return response.data;
            } catch (error) {
                console.error('Failed to update TRS Registration:', error);
                throw error;
            }
        },
        onSuccess: (data, variables) => {
            // Invalidate and refetch related queries
            queryClient.setQueryData(['TRSRegistration', variables.id], data);
            queryClient.invalidateQueries(['TRSRegistrations']);

            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            console.error('Failed to update TRS Registration:', error);
            if (onError) {
                onError(error);
            }
        },
    });

    return mutation;
};

export default useUpdateTRSRegistration;
